import { fillAssetFinanceCompareProduct } from '__core/shared/util/salestrekker';
import template from './assetFinanceCompareProducts.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    assetDetails: '<',
    compareProducts: '<',
    searchFields: '<',
    filteredLenders: '<',
    lenders: '<',
    documents: '<',
    contacts: '<',
    income: '<',
    expenses: '<',
    assets: '<',
    liabilities: '<',
    ticketClientTypes: '<',
    workflow: '<',
    ticketOwner: '<',
    idTicket: '<',
    isDealOwnerBroker: '<',
    isCommercial: '<',
    isQuickTool: '<',
    isTicketSettled: '<',
    onToggleProductAsPreferred: '&',
    onChanged: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $timeout,
      $mdUtil,
      $mdMedia,
      eventService,
      helperService,
      financesService,
      productsService,
      assetFinanceService,
      AssetFinanceCompareProduct,
      PaymentFrequency
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableTermInMonths = [];
      ctrl.availablePaymentFrequencies = [];
      ctrl.availableProductFeeTypes = [];
      ctrl.availableProductTypes = [];
      ctrl.chart = {
        isReady: false,
        data: []
      };
      ctrl.isProcessing = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.assetDetails = ctrl.assetDetails || {};
        ctrl.compareProducts = ctrl.compareProducts || [];
        ctrl.searchFields = ctrl.searchFields || {};
        ctrl.filteredLenders = ctrl.filteredLenders || [];
        ctrl.lenders = ctrl.lenders || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.income = ctrl.income || [];
        ctrl.expenses = _.filter(ctrl.expenses || [], (e) => e?.id && _.isUuid(e?.id));
        ctrl.assets = ctrl.assets || [];
        ctrl.liabilities = ctrl.liabilities || [];
        ctrl.ticketClientTypes = ctrl.ticketClientTypes || [];
        ctrl.workflow = ctrl.workflow || {};
        ctrl.ticketOwner = ctrl.ticketOwner || {};
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.isDealOwnerBroker = ctrl.isDealOwnerBroker || [];
        ctrl.isCommercial = ctrl.isCommercial || false;
        ctrl.isQuickTool = ctrl.isQuickTool || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.availableTermInMonths = helperService.getAvailableTermInMonths({
          isRegular: true
        });
        ctrl.availablePaymentFrequencies = helperService.getAvailablePaymentFrequencies({
          workflow: ctrl.workflow,
          loanPurpose: ctrl.isCommercial ? 'commercial' : 'consumer'
        });
        ctrl.availableProductFeeTypes = helperService.getAvailableProductFeeTypes();
        ctrl.availableProductTypes = assetFinanceService.getAvailableProductTypes({
          isCommercial: ctrl.isCommercial
        });
        if (ctrl.compareProducts?.length > 4) {
          const pLen = ctrl.compareProducts?.length || 0;
          ctrl.compareProducts = ctrl.compareProducts.splice(pLen - 4, pLen - 1);
          // ctrl.setCommissionsPayable();
          ctrl.saveCompareProducts();
        } else if (ctrl.compareProducts?.length <= 4 && !ctrl.isTicketSettled) {
          ctrl.isProcessing = true;
          ctrl.assetFinanceCompareProductEstimate();
        }
        ctrl.isReady = true;
      };

      ctrl.showLeaseFields = (compareProduct) =>
        compareProduct.productDetails.productType === 2 ||
        compareProduct.productDetails.productType === 3 ||
        compareProduct.productDetails.productType === 7;

      // ctrl.setCommissionsPayable = () => {
      //   TODO: This is currently not use until we get how to exactly should be worked
      //   if (!ctrl.isCommercial && ctrl.organizationCountry?.cca2 !== 'NZ') {
      //     const len = ctrl.compareProducts?.length || 0;
      //     for (let c = 0; c < len; c += 1) {
      //       const compareProduct = ctrl.compareProducts[c];
      //       const lender = _.find(
      //         ctrl.ticketOwner?.lenderAccreditations || [],
      //         (l) => l?.idLender === compareProduct?.selectedProduct?.lender[0]?.id
      //       );
      //       compareProduct.commissionsPayable.upfront = lender
      //         ? _.multiply(
      //             _.divide(lender?.upfront || 0, 100),
      //             compareProduct?.productDetails?.brokerCommissionValue || 0
      //           )
      //         : 0;
      //       compareProduct.commissionsPayable.trail = lender
      //         ? _.divide(
      //             _.multiply(
      //               _.divide(lender?.trail || 0, 100),
      //               compareProduct?.productDetails?.brokerOriginationFee || 0
      //             ),
      //             12
      //           )
      //         : 0;
      //     }
      //     ctrl.saveCompareProducts(true);
      //   }
      // };

      ctrl.setChartOfCompareLoanProducts = () => {
        ctrl.chart.isReady = false;
        $timeout(() => {
          ctrl.chart = helperService.setChartOfCompareLoanProducts({
            compareProducts: ctrl.compareProducts
          });
        });
      };

      ctrl.toggleProductAsPreferred = (idx) => {
        if (idx > -1) {
          ctrl.onToggleProductAsPreferred({ idx });
          ctrl.setChartOfCompareLoanProducts();
          ctrl.saveCompareProducts(true);
        }
      };

      ctrl.compareProductDelete = (idx) => {
        ctrl.compareProducts.splice(idx, 1);
        ctrl.setChartOfCompareLoanProducts();
        ctrl.saveCompareProducts();
      };

      ctrl.isAnyOfProductsSetAsPreferred = () =>
        _.some(ctrl.compareProducts, (p) => p.isPreferred);

      ctrl.getBrokerCommissionLabelName = ({ compare, isPercent }) => {
        let labelName = `Broker commission ${isPercent ? 'percent' : 'value'} (net of GST)`;
        if (compare?.selectedProduct?.assetFinance?.brokerCommission === 4) {
          labelName = `Broker commission ${isPercent ? 'percent' : 'value'} (including GST)`;
        }
        if (ctrl.isProductTypeLeaseAndAnzLender(compare)) {
          labelName = `Broker commission ${isPercent ? 'percent' : 'value'}`;
        }
        return labelName;
      };

      ctrl.getRepaymentLabelName = (compareProduct) => {
        if (ctrl.showLeaseFields(compareProduct)) {
          return `${
            compareProduct?.productDetails?.productType === 2
              ? 'Total rental'
              : `${
                  compareProduct?.productDetails?.paymentFrequency?.name !==
                  PaymentFrequency.none.name
                    ? compareProduct?.productDetails?.paymentFrequency.title
                    : 'N/A'
                } repayment`
          } <small>(GST: ${(
            compareProduct?.productDetails?.gstOfEstimatedRepayment || 0
          ).formatWithCurrency(ctrl.currentCurrency, 2)})</small>:`;
        }
        return `${
          compareProduct?.productDetails?.productType === 2
            ? 'Total rental'
            : `${
                compareProduct?.productDetails?.paymentFrequency?.name !==
                PaymentFrequency.none.name
                  ? compareProduct?.productDetails?.paymentFrequency.title
                  : 'N/A'
              } repayment`
        }:`;
      };

      ctrl.hasNoPreferredProduct = () =>
        assetFinanceService.getPreferredProduct(ctrl.compareProducts) === undefined;

      ctrl.getInterestRateTitle = (interestRate) => {
        const title = ctrl.isCommercial ? 'Base interest rate:' : 'Published rate:';
        return interestRate === 0 ? `${title} (refer to lender)` : title;
      };

      ctrl.getFeeType = (fee) => {
        const feeType = _.find(ctrl.availableProductFeeTypes, (t) => t.id === fee.type);
        return feeType ? feeType.value : 'N/A';
      };

      ctrl.getFeeValue = (fee) => {
        const feeType = _.find(ctrl.availableProductFeeTypes, (t) => t.id === fee.type);
        return feeType?.id === 'ORIGINATION' && fee.value === 0
          ? 'Refer to notes'
          : fee.value.formatWithCurrency(ctrl.currentCurrency, 2);
      };

      ctrl.getLender = (idLender) => _.find(ctrl.filteredLenders, (l) => l?.id === idLender);

      ctrl.hasLender = (idLender) => ctrl.getLender(idLender);

      ctrl.getLenderName = (idLender) => {
        const lender = ctrl.getLender(idLender);
        const notExistingLender = _.find(ctrl.lenders, (l) => l?.id === idLender);
        return lender ? lender.getName() : notExistingLender.getName();
      };

      ctrl.getLenderDocument = (idLender) => {
        const doc = _.find(
          ctrl.documents,
          (d) => d?.lender[0]?.id === idLender && d?.type.indexOf('LOGO') > -1
        );
        return doc?.url || '';
      };

      ctrl.isAnzSelectedAsLender = ({ product }) =>
        assetFinanceService.isAnzSelectedAsLender({ product });

      ctrl.isProductTypeLeaseAndAnzLender = ({ product }) =>
        assetFinanceService.isProductTypeLeaseAndAnzLender({ product });

      ctrl.showEditableFields = (product) =>
        assetFinanceService.showEditableFields({ product });

      ctrl.showWarning = (product) =>
        ctrl.showEditableFields(product) &&
        (!product.productDetails.balloonValue ||
          !product.productDetails.estimatedBorrowerRate ||
          !product.productDetails.estimatedRepaymentWithGst);

      ctrl.brokerCommissionCase = ({ compare }) =>
        compare?.selectedProduct?.assetFinance?.brokerCommission !== 1 &&
        compare?.selectedProduct?.assetFinance?.brokerCommission !== 4 &&
        compare?.selectedProduct?.assetFinance?.brokerCommission !== 6 &&
        compare?.selectedProduct?.assetFinance?.brokerCommission !== 10;

      ctrl.isBrokerOriginationFeeDisabled = ({ compare }) =>
        (compare?.selectedProduct?.assetFinance?.brokerCommission === 8 ||
          compare?.selectedProduct?.assetFinance?.brokerCommission === 9 ||
          compare?.selectedProduct?.assetFinance?.brokerCommission === 10 ||
          compare?.selectedProduct?.assetFinance?.brokerCommission === 11) &&
        !compare?.productDetails?.isUpfrontFeeCapitalised;

      ctrl.showProcessingAndBrokerFees = () =>
        !ctrl.isCommercial && ($rootScope.isDev() || $rootScope.isPtf() || $rootScope.isNlg());

      ctrl.assetFinanceCompareProductEstimate = () => {
        financesService
          .assetFinanceProductsCompare({
            idTicket: ctrl.idTicket
          })
          .then((res) => {
            if (res?.status && res?.products?.length) {
              const len = res?.products?.length || 0;
              for (let p = 0; p < len; p += 1) {
                const product = res?.products[p];
                const idx = _.findIndex(
                  ctrl.compareProducts || [],
                  (c) => c?.id === product?.key
                );
                if (idx > -1) {
                  ctrl.compareProducts[idx] = fillAssetFinanceCompareProduct(
                    ctrl.compareProducts[idx],
                    product
                  );
                  const data = {
                    compareProducts: ctrl.compareProducts
                  };
                  ctrl.onChanged({ data });
                }
              }
            }
            ctrl.setChartOfCompareLoanProducts();
            // ctrl.setCommissionsPayable();
            ctrl.isProcessing = false;
          });
      };

      ctrl.compareProductChanges = _.debounce(() => {
        ctrl.saveCompareProducts();
      }, 3000);

      ctrl.saveCompareProducts = (isSilent) => {
        ctrl.isProcessing = !isSilent;
        const data = {
          compareProducts: ctrl.compareProducts,
          aFCD: !isSilent ? 'assetFinanceCompareProducts' : ''
        };
        ctrl.onFinished({ data });
      };

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'assetFinanceCompareProducts') {
          ctrl.assetFinanceCompareProductEstimate();
        } else {
          ctrl.isProcessing = false;
        }
      });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
